var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1001_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1003_",
    d: "M24.38,2.64H1.62C0.73,2.64,0,3.37,0,4.27v17.47c0,0.9,0.73,1.62,1.62,1.62h22.75 c0.9,0,1.62-0.73,1.62-1.62V4.27C26,3.37,25.27,2.64,24.38,2.64z M24.32,21.73l-6.9-6.89c-0.1-0.1-0.26-0.1-0.35,0l-1.59,1.59 l-4.06-4.06c-0.1-0.1-0.26-0.1-0.35,0L1.7,21.73H1.62V4.27h22.75l0,17.47H24.32z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1002_",
    cx: 20.01,
    cy: 9.71,
    r: 1.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.ffb49e34e62869f058ca91f0b7851328.svg";
export { ForwardRef as ReactComponent };